import React from 'react';
import { PaginationBtn } from '~/libs/ui/atoms/PaginationBtn';
import { Pagination } from '~/libs/infrastructure/schemas/paginations';

export interface Props {
	pagination: Pagination;
	onChange(page: number): void;
}

export function PaginationPanel({ pagination, onChange }: Props) {
	const { currentPage, totalPages } = pagination;

	const button2 = () => {
		if (currentPage > 3 && totalPages > 7) {
			return null;
		}
		return 2;
	};
	const button3 = () => {
		if (currentPage <= 3 || totalPages <= 7) {
			return 3;
		}
		if (currentPage > totalPages - 4) {
			return totalPages - 4;
		}
		return currentPage - 1;
	};
	const button4 = () => {
		if (currentPage <= 3 || totalPages <= 7) {
			return 4;
		}
		if (currentPage > totalPages - 4) {
			return totalPages - 3;
		}
		return currentPage;
	};
	const button5 = () => {
		if (currentPage <= 3 || totalPages <= 7) {
			return 5;
		}
		if (currentPage > totalPages - 4) {
			return totalPages - 2;
		}
		return currentPage + 1;
	};
	const button6 = () => {
		if (currentPage < totalPages - 2 && totalPages > 7) {
			return null;
		}
		return totalPages - 1;
	};

	return (
		<nav
			className={`mt-2 flex justify-start items-start border border-gray-200 divide-x divide-gray-50 rounded bg-white overflow-hidden ${
				totalPages <= 1 ? 'hidden' : ''
			}`}
		>
			<PaginationBtn active={currentPage === 1} hidden={false} value={1} onClick={onChange} />
			<PaginationBtn active={currentPage === 2} hidden={totalPages <= 2} value={button2()} onClick={onChange} />
			<PaginationBtn active={currentPage === 3} hidden={totalPages <= 3} value={button3()} onClick={onChange} />
			<PaginationBtn active={currentPage === button4()} hidden={totalPages <= 4} value={button4()} onClick={onChange} />
			<PaginationBtn active={currentPage === button5()} hidden={totalPages <= 5} value={button5()} onClick={onChange} />
			<PaginationBtn active={currentPage === button6()} hidden={totalPages <= 6} value={button6()} onClick={onChange} />
			<PaginationBtn
				active={currentPage === totalPages}
				hidden={totalPages <= 1}
				value={totalPages}
				onClick={onChange}
			/>
		</nav>
	);
}
